<template>
	<!-- *********************************************
	*             Operation information              *
	********************************************** -->
	<!-- Origin Card Block -->
	<divider-generic dividerSize="medium" icon="credit-card" :title="t('cards.transfers.flex.step2.originCardTitle')" :applyBorder="false"/>
	<text-block-generic
	:params="{
		label: t('cards.transfers.flex.step2.originCard'),
		content: cardNumber(formData.originCard)
	}"/>
	<!-- Destination Card Block -->
	<divider-generic dividerSize="medium" icon="credit-card" :title="t('cards.transfers.flex.step2.destinationCardTitle')" :applyBorder="false"/>
	<text-block-generic
	:params="{
		label: t('cards.transfers.flex.step2.destinationCard'),
		content: cardNumber(formData.destinationCard)
	}"/>
	<!-- Total Amount Block -->
	<divider-generic dividerSize="medium" icon="coin-drop" :title="t('cards.transfers.flex.step1.amountTitle')" :applyBorder="false"/>
	<text-block-generic
	:params="{
		label: t('cards.transfers.flex.step2.amountToTransfer'),
		content: amountFormat(formData.amount, ACCOUNT_MAIN_CURRENCY)
	}"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue */
import { onMounted } from 'vue'

/* Assets & Helpers */
import { amountFormat } from '@/assets/scripts/amounts'
import { ACCOUNT_MAIN_CURRENCY } from '@/assets/constants/accounts'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['scrollTo'])

/** Props
@formData {Object} Object with info for our current form
@getCardsList {Object} object with cards to retrieve card number from it's id
*/

const props = defineProps({
	formData: Object,
	getCardsList: Object
})

const cardNumber = cardId => {
	return props.getCardsList.find(card => card.id === cardId).cardNumber
}

onMounted(() => {
	emit('scrollTo', 0)
})
</script>

<style lang="scss" scoped>
</style>
